import React from 'react';
import { FaCheck } from 'react-icons/fa';

import {
  FlexCol,
  FlexGrid,
  FlexRow,
} from '../../../../../common/components/v2';
import { Resource } from '../../../../../common/constants/resource';
import { MedExam } from '../../../../tasks/types/medExam';
import { ReasonsSummary } from '../../ReasonsSummary';
import styles from '../../styles.module.scss';

const ItemSummary = ({ displayString }: { displayString: string }) => {
  return (
    <FlexRow>
      <FlexCol xs={1} sm={1} lg={1}>
        <FaCheck />
      </FlexCol>
      <FlexCol xs={11} sm={11} lg={11}>
        <span className={styles.Info}>{displayString}</span>
      </FlexCol>
    </FlexRow>
  );
};

export const MedExamSummary = ({ medExam }: { medExam: MedExam }) => {
  return (
    <FlexGrid>
      <FlexRow>
        <label className={styles.EvidenceTitle}>Medical Exams</label>
      </FlexRow>
      <FlexRow>
        <label className={styles.DrawerSubTitle}>TYPE</label>
      </FlexRow>
      {medExam.labs && (
        <ItemSummary
          displayString={['Labs', ...medExam.labsOptions].join(' · ')}
        />
      )}
      {medExam.physicalMeasurements && (
        <ItemSummary displayString={'Physical Measurements'} />
      )}
      {medExam.ekg && <ItemSummary displayString={'EKG'} />}
      <ReasonsSummary
        title={Resource.ORDER_REASON}
        reasons={medExam.reason}
        description={medExam.reasonDescription}
      />
    </FlexGrid>
  );
};
